import type { ModelInformationView } from "@slfinrtl/ui-bff-routes"
import { getModelInformationRoute } from "@slfinrtl/ui-bff-routes"
import { useEffect, useState } from "react"
import { useBff } from "src/hooks"
import { useVehicleDetailsContext } from "src/screens/vehicleDetails/context/VehicleDetailsContext"
import type { ModelInformationDetailsProps } from "../../components/ModelInformationDetails"

export const useModelInformation = (): ModelInformationDetailsProps | undefined | null => {
	const [modelInformationView, setModelInformationView] = useState<ModelInformationView | null>()
	const { inventoryId, notify } = useVehicleDetailsContext()

	const fetchModelInformationDetails = useBff(
		getModelInformationRoute,
		{
			body: undefined,
			pathParams: {},
			queryParams: {
				"inventory-id": inventoryId,
			},
		},
		"inline",
	)

	useEffect(() => {
		fetchModelInformationDetails()
			.then(setModelInformationView)
			.catch(() => setModelInformationView(null))
	}, [fetchModelInformationDetails])

	useEffect(() => {
		if (modelInformationView !== undefined) {
			notify({ event: "modelInformationChanged", payload: modelInformationView })
		}
	}, [modelInformationView, notify])

	return modelInformationView
		? {
				countryVehicleSpecification: modelInformationView.countryVehicleSpecification,
				derivative: modelInformationView.orderTypeName,
				driveTrain: modelInformationView.driveTrain,
				engineType: modelInformationView.engineType,
				modelGeneration: modelInformationView.modelGeneration,
				modelSeries: modelInformationView.modelSeries,
				modelYear: modelInformationView.modelYear.toString(),
				orderTypeName: `${modelInformationView.orderTypeName} (${modelInformationView.orderTypeCode})`,
				transmission: modelInformationView.transmission,
			}
		: modelInformationView
}
